module.exports = __webpack_public_path__ + "img/201.700820b6.png";